/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { Ref, MouseEventHandler, ChangeEventHandler, forwardRef } from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useTheme } from "@mui/material";

interface Props {
  inputRef?: Ref<HTMLInputElement>;
  value?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  valid?: boolean;
}

export const DatePickerInput = forwardRef<HTMLInputElement, Props>(
  ({ inputRef, value, disabled, onClick, valid }, ref) => {
    const theme = useTheme();
    return (
      <Paper
        variant="outlined"
        style={{ border: "1px solid rgba(0, 0, 0, 0.23)" }}
        component="form"
        sx={{
          display: "flex",
          alignItems: "center",
          flexGrow: 1,
          backgroundColor: valid ? undefined : theme.palette.error.main,
          height: "100%",
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="DD/MM/YYYY"
          inputProps={{ "aria-label": "DD/MM/YYYY" }}
          value={value}
          disabled={disabled}
        />
        <IconButton
          type="button"
          sx={{ p: "10px" }}
          aria-label="search"
          onClick={onClick}
          disabled={disabled}
        >
          <CalendarMonthIcon />
        </IconButton>
      </Paper>
    );
  }
);
